export default __webpack_public_path__ + "static/media/layers.5d347130.svg";